import Vue from 'vue'

const initialState = {
  detail: {
    maintainers: [],
    executors: []
  },
  list: [],
  loading: false,
  task: {},
  employeeTasks: [],
  employeeTasksRelations: {}
}

export default {
  namespaced: true,
  state: {
    ...initialState
  },
  getters: {
    executors(state) {
      return state.detail.executors.map(executor => executor.employee.id)
    },
    getProjectById: state => id => {
      return state.projects.find(project => project.id === parseInt(id))
    }
  },
  mutations: {
    SET(state, data) {
      state[data.key] = data.val
    },
    CLEAR(state, key = false) {
      if (key)
        state[key] = initialState[key]
      else state = {...initialState}
    },
    ADD_FILE(state, file) {
      state.detail = {
        ...state.detail,
        states: state.detail.states.map((documentState, i, states) => {
          if (i === states.length - 1) {
            documentState.attachments = [...documentState.attachments, file]
          }
          return documentState
        })
      }
    },
    REMOVE_FILE(state, fileId) {
      state.detail = {
        ...state.detail,
        states: state.detail.states.map(documentState => {
          return {
            ...documentState,
            attachments: documentState.attachments.filter(file => file.id !== fileId)
          }
        })
      }
    },
    ADD_DOCUMENT_STATE(state, documentState) {
      state.detail = {
        ...state.detail,
        state: documentState.state,
        states: [...state.detail.states, documentState]
      }
    },
    ADD_EXECUTOR(state, executor) {
      state.detail = {
        ...state.detail,
        executors: [...state.detail.executors, executor]
      }
    },
    REMOVE_EXECUTOR(state, executorId) {
      state.detail = {
        ...state.detail,
        executors: state.detail.executors.filter(executor => executor.id !== executorId)
      }
    }
  },
  actions: {
    list({commit}, {documentId, params}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`workflow/documents/${documentId}/tasks/`, {params}).then(response => {
          commit('SET', {
            key: 'list',
            val: response.data
          })
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getDetail({commit, state}, {taskId, documentId}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`workflow/documents/${documentId}/tasks/${taskId}/`).then(response => {
          commit('SET', {
            key: 'detail',
            val: {...response.data, document: documentId}
          })
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    uploadFile({commit, state}, file) {
      let data = new FormData()
      data.append('file', file)
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.post(`workflow/documents/${state.detail.document}/tasks/${state.detail.id}/attachments/`, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(response => {
          commit('ADD_FILE', response.data)
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    removeFile({commit, state}, fileId) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.delete(
          `workflow/documents/${state.detail.document}/tasks/${state.detail.id}/attachments/${fileId}/`
        ).then(() => {
          commit('REMOVE_FILE', fileId)
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    nextState({commit, state}, note) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.post(
          `workflow/documents/${state.detail.document}/tasks/${state.detail.id}/next_state/`,
          {note}
        ).then(response => {
          commit('ADD_DOCUMENT_STATE', response.data)
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    reject({commit, state}, note) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.post(
          `workflow/documents/${state.detail.document}/tasks/${state.detail.id}/reject/`,
          {note}
        ).then(response => {
          commit('ADD_DOCUMENT_STATE', response.data)
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    restore({commit, state}, note) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.post(
          `workflow/documents/${state.detail.document}/tasks/${state.detail.id}/restore/`,
          {note}
        ).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getRelations({commit, state}, {documentId, taskId}) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`workflow/documents/${documentId}/tasks/${taskId}/`).then(response => {
          commit('SET', {
            key: 'task',
            val: {
              id: taskId,
              document: documentId,
              description: response.data.description,
              type: response.data.type,
              term_date : response.data.term_date,
            }
          })
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    create({commit}, {task, documentId}) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.post(`workflow/documents/${documentId}/tasks/`, task).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    update({commit}, task) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.put(`workflow/documents/${task.document}/tasks/${task.id}/`, task).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    addExecutor({commit, state}, employeeId) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.post(`workflow/documents/${state.detail.document}/tasks/${state.detail.id}/executors/`, {
          employee: employeeId,
          type: 'executor'
        }).then((response) => {
          commit('ADD_EXECUTOR', {...response.data, can_delete: true})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    removeExecutor({commit, state}, executorId) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.delete(
          `workflow/documents/${state.detail.document}/tasks/${state.detail.id}/executors/${executorId}/`
        ).then(() => {
          commit('REMOVE_EXECUTOR', executorId)
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    cancel({commit, state}, note) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.post(
          `workflow/documents/${state.detail.document}/tasks/${state.detail.id}/cancel/`,
          {note}
        ).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    employeeTasks({commit}, params) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get('workflow/employee_tasks/', {params}).then(response => {
          commit('SET', {
            key: 'employeeTasks',
            val: response.data.results
          })
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getEmployeeTasksRelations({commit}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get('workflow/employee_tasks/relations/').then(response => {
          commit('SET', {
            key: 'employeeTasksRelations',
            val: response.data
          })
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
  }
}
